module.exports = __webpack_public_path__ + "img/file-spreadsheet.b98011e9.svg";